import { useCallback } from "react";

import type { DesignSnackLayoutSettingsFormModelOnSetViewModelType } from "../..";
import type { DesignSnackBlocksFormModel } from "../../type";

type Props = {
	viewModel: DesignSnackBlocksFormModel["ViewModel"];
	onSetViewModel: DesignSnackLayoutSettingsFormModelOnSetViewModelType;
};

export const useSnackSettingsFormModelLanguageSwitcherMethods = ({ viewModel, onSetViewModel }: Props) => {
	const { isShowLanguageSwitcher } = viewModel;

	const handleChangeIsShowLanguageSwitcher = useCallback(
		(value: string) => {
			const next = value === "true";
			onSetViewModel([
				{
					key: "isShowLanguageSwitcher",
					value: {
						isEdited: true,
						value: next,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isShowLanguageSwitcher: Boolean(isShowLanguageSwitcher?.value),
		handleChangeIsShowLanguageSwitcher,
	};
};
